import { Row } from 'antd';
import styled from 'styled-components';

export const StyledRow = styled(Row)`
    height: 300px;
`;
